var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { plainToClass } from 'class-transformer';
import Appointment from 'models/entities/Appointment';
import Patient from 'models/entities/Patient';
import ServiceOrder from 'models/entities/ServiceOrder';
import Model from 'models/Model';
var PatientJourneyStep = /** @class */ (function (_super) {
    __extends(PatientJourneyStep, _super);
    function PatientJourneyStep() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PatientJourneyStep.prototype.getId = function () {
        return Number(this.id);
    };
    PatientJourneyStep.prototype.getPosition = function () {
        return Number(this.position || 0);
    };
    PatientJourneyStep.prototype.getPatientJourneyId = function () {
        return Number(this.patient_journey_id);
    };
    PatientJourneyStep.prototype.getQueueNumber = function () {
        return this.number == null ? undefined : Number(this.number);
    };
    PatientJourneyStep.prototype.getArrivedAt = function () {
        return this.arrived_at || undefined;
    };
    PatientJourneyStep.prototype.getClinicId = function () {
        return this.clinic_id == null ? undefined : Number(this.clinic_id);
    };
    PatientJourneyStep.prototype.getServiceOrderId = function () {
        return this.service_order_id == null ? undefined : Number(this.service_order_id);
    };
    PatientJourneyStep.prototype.getStepableType = function () {
        return this.stepable_type;
    };
    PatientJourneyStep.prototype.getStepableId = function () {
        return Number(this.stepable_id);
    };
    PatientJourneyStep.prototype.getStepKind = function () {
        return this.step_kind || 'other';
    };
    PatientJourneyStep.prototype.getNotes = function () {
        return this.notes || '';
    };
    PatientJourneyStep.prototype.getCurrentState = function () {
        return this.current_state || 'pending';
    };
    PatientJourneyStep.prototype.getServiceOrder = function () {
        if (this.stepable_type !== 'ServiceOrder' || !this.stepable)
            return undefined;
        return plainToClass(ServiceOrder, this.stepable);
    };
    PatientJourneyStep.prototype.getAppointment = function () {
        if (this.stepable_type !== 'Appointment' || !this.stepable)
            return undefined;
        return plainToClass(Appointment, this.stepable);
    };
    PatientJourneyStep.prototype.getPatient = function () {
        return this.patient ? plainToClass(Patient, this.patient) : undefined;
    };
    PatientJourneyStep.prototype.isTerminal = function () {
        return ['done', 'skipped', 'cancelled'].includes(this.getCurrentState());
    };
    return PatientJourneyStep;
}(Model));
export default PatientJourneyStep;
